import React from "react";

import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer">
      <p>©2024 Die Tankstellenhelden.</p>
      <ul>
        <li>Impressum</li>
        <li>Datenschutz</li>
        <li>Kontakt</li>
      </ul>
    </div>
  );
};

export default Footer;
